<script setup lang="ts">
import {reactive} from 'vue';
import Toast from './Toast.vue';
import ErrorToast from "./ErrorToast.vue";

defineExpose({
  toastError
});

let idCounter = 0

const errors: {
  id: number
  code?: string
  title?: string
  message?: string
}[] = reactive([]);

function toastError(error: {
  code?: string
  title?: string
  message?: string
}) {
  errors.splice(0, 0, {
    ...error,
    id: idCounter++
  });
}

function removeError(id: number) {
  const idx = errors.findIndex(r => r.id === id);
  if (idx >= 0) {
    errors.splice(idx, 1);
  }
}
</script>

<template>
  <div
    class="toast-panel"
  >
    <Toast
      v-for="err in errors"
      :key="err.id"
      @remove="() => removeError(err.id)"
      class="toast"
    >
      <ErrorToast :error="err" @close="() => removeError(err.id)" />
    </Toast>
  </div>
</template>

<style>
.toast-panel {
  position: fixed;
  bottom: 10px;
  left: 10px;
  width: 400px;
  max-width: calc(100% - 70px);
  overflow: hidden;
  display: grid;
  grid-auto-flow: row;
  gap: 5px;
}

</style>